import React, {Component, useEffect, useState} from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import connect from "react-redux/es/connect/connect";
import {
    getAutoclaveHistoricoIndicadores,
    getAutoclaves, getOSPorEtapaMaquinaCiclo
} from "../../../actions/autoclaveActions";
import AutoclaveLotarOSTabela from "./AutoclaveLotarOSTabela";
import AutoclaveCicloGraficoIndicadores from "./AutoclaveCicloGraficoIndicadores";
import AutoclaveCicloGraficoEventos from "./AutoclaveCicloGraficoEventos";
import AutoclaveCicloGraficoAlarmes from "./AutoclaveCicloGraficoAlarmes";
import AutoclaveCicloGraficoPresets from "./AutoclaveCicloGraficoPresets";
import AutoclaveCicloDistinctPresets from "./AutoclaveCicloDistinctPresets";
import {Paper} from "@material-ui/core";
import {useSelector} from "react-redux";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    newServiceOrderTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    leftMargin: {
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    infoIcon: {
        verticalAlign: "middle"
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    relative: {
        position: 'relative'
    },
    formControl: {
        marginRight: theme.spacing(1),
        minWidth: theme.spacing(1) * 10,
    },
    textCenter: {
        textAlign: 'center'
    },
    marginChart: {
        marginBottom: '20px'
    }
}));




const AutoclaveCicloDetalhes = (props) => {
    const classes = useStyles();

    const ciclosDados = useSelector( state => state.autoclaves.ciclosDados);
    const { autoclaveId, autoclaveCodigo, ciclo } = props;

    let cicloDados = ciclosDados.find( (c) => parseInt( c.autoclaveId) === parseInt(autoclaveId) && c.ciclo === ciclo );


    if (typeof(cicloDados) === "undefined") {
        return (<React.Fragment/>);
    }

    const renderObservacoes = () => {
        if (cicloDados && cicloDados.observacoes) {
            return (
                <React.Fragment>
                    <Typography variant="h5" >Observações</Typography>
                    <Grid item xs={12} md={12} xl={12} lg={12} className={classes.marginChart}>
                        <Paper>

                            <Typography variant="subtitle1">{cicloDados.observacoes}</Typography>
                        </Paper>

                    </Grid>
                </React.Fragment>
            )
        }
    }
    
    

    let cicloChart = (<React.Fragment/>)
    if (cicloDados) {


        cicloChart = (
            <React.Fragment>
                <Typography variant="h5" >Processo</Typography>
                <Grid item xs={12} md={12} xl={12} lg={12} className={classes.marginChart}>
                    <AutoclaveCicloGraficoIndicadores
                        // ciclo={this.props.autoclave.AutoclaveCicloIndicadores}
                        autoclaveId={autoclaveId}
                        cicloId={ciclo}
                    />
                </Grid>
                {renderObservacoes()}
                <Typography variant="h5" >Presets</Typography>
                <Grid item xs={12} md={12} xl={12} lg={12} className={classes.marginChart}>
                    <AutoclaveCicloDistinctPresets
                        ciclo={cicloDados.AutoclaveCicloDistinctPresets}
                    />
                </Grid>
                <Typography variant="h5" >Alarmes</Typography>
                <Grid item xs={12} md={12} xl={12} lg={12} className={classes.marginChart}>
                    <AutoclaveCicloGraficoAlarmes
                        ciclo={cicloDados.AutoclaveCicloAlarmes}
                        tagAlarmes={cicloDados.AutoclaveCicloTagAlarmes}
                    />
                </Grid>
                <Typography variant="h5" >Eventos</Typography>
                <Grid item xs={12} md={12} xl={12} lg={12}  className={classes.marginChart}>
                    <AutoclaveCicloGraficoEventos
                        ciclo={cicloDados.AutoclaveCicloEventos}
                    />
                </Grid>
                <Typography variant="h5" >Presets</Typography>
                <Grid item xs={12} md={12} xl={12} lg={12} className={classes.marginChart}>
                    <AutoclaveCicloGraficoPresets
                        ciclo={cicloDados.AutoclaveCicloPresets}
                    />
                </Grid>

            </React.Fragment>);
    }


    return ( <React.Fragment>
        <Grid container>
            <Grid item xs={12} md={12} xl={12} lg={12} className={classes.marginChart}>
                <Typography variant="h5" >Autoclave: {autoclaveCodigo} Ciclo: {ciclo} </Typography>
                <AutoclaveLotarOSTabela
                    autoclaveId={autoclaveId}
                    autoclaveCodigo={autoclaveCodigo}
                    ciclo={ciclo}
                    selectciclo={ciclo}

                />
            </Grid>
            {cicloChart}
        </Grid>
    </React.Fragment>)
}


export default (AutoclaveCicloDetalhes);




  
   


  



